import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { serverApi } from './api';
import { authTokenSlice } from './auth-token-slice';

export const store = configureStore({
  reducer: {
    [serverApi.reducerPath]: serverApi.reducer,
    auth: authTokenSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(serverApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
